module.exports = __webpack_public_path__ + "static/media/index_replication.7d1c9696.webp";